import { APP_API_URL } from '@/constants';
import { getContext, isContextAvailable } from '@/miniappContext';
import { setAppStore } from '@/store';

const CREDITS_URL = `${import.meta.env.VITE_SDK_API_URL || `${APP_API_URL}`}/guard/credits`;

interface CreditsResponse {
  status?: string;
  response?: { credits?: number; addonCredits?: number };
}

export const getAvailableCredits = async (): Promise<void> => {
  if (!isContextAvailable()) {
    setAppStore({ availableCreditsLoaded: true });
    return;
  }
  try {
    const response = await getContext().utils.api.fetch(CREDITS_URL);
    if (!response.ok) {
      console.warn(`[creditUtils] credits request failed (${response.status})`);
      return;
    }

    const text = await response.text();
    if (!text) {
      console.warn('[creditUtils] credits response body is empty');
      return;
    }

    const data = JSON.parse(text) as CreditsResponse;
    const info = data?.response;
    if (data?.status !== 'success' || !info) {
      console.warn('[creditUtils] credits response not successful:', data?.status);
      return;
    }

    const total = (info.credits ?? 0) + (info.addonCredits ?? 0);
    setAppStore({ availableCredits: total, availableCreditsLoaded: true });
  } catch (err) {
    console.error('[creditUtils] Failed to fetch credits:', err);
  } finally {
    setAppStore({ availableCreditsLoaded: true });
  }
};
